import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { TarjetasPactar } from './pages/TarjetasPactar'
import { ComerciosPactar } from './pages/ComerciosPactar'
import { PaquetesNyPSP } from './pages/PaquetesNyPSP'
import { TarjetasCreditoSP } from './pages/TarjetasCreditoSP'
import { PaquetesBancaIndividuoSP } from './pages/PaquetesBancaIndividuoSP'
import { PrestamosPersonalSP } from './pages/PrestamoPersonalSP'
import { ArrepentimientoPreSolicitud } from './pages/ArrepentimientoPreSolicitud'
import { ArrepentimientoIndex } from './pages/ArrepentimientoIndex';
import HomeRedirect from './components/HomeRedirect';
import { BloqueoBip } from "./pages/BloqueoBip";
import { CajasDeSeguridad } from './pages/CajasDeSeguridad';
import { AdhesionComerciosCanje } from './pages/AdhesionComerciosCanje';
import { AdhesionComercioProvinciaCompras } from "./pages/AdhesionComercioProvinciaCompras";
import { DemandaColectivaIFE } from './pages/DemandaColectivaIFE';
import { PUSFForm } from './pages/PUSFForm';
import { FileUploadPage } from './pages/FileUploadPage';
import { ConfirmacionEntradas } from './pages/ConfirmacionEntradas';
import { CONFIRMACION_ENTRADAS_VIG_END, CONFIRMACION_ENTRADAS_VIG_START } from './Constantes';
import { CtaPersonaJuridicaPresolicitud } from "./pages/CtaPersonaJuridicaPresolicitud";
import { CreditoDamnificadosBahiaBlanca } from "./pages/CreditoDamnificadosBahiaBlanca";
import { TurnstileProvider } from './components/Contexto/TurnstileTokenContext';
import { AdhesionPortalPrestamosADistancia } from './pages/AdhesionPortalPrestamosADistancia';
import { AdhesionComercios } from './pages/AdhesionComercios';
import { AdhesionComerciosPreSolicitudForm } from './pages/AdhesionComerciosPreSolicitudForm';
import { ProvinciaIntegra } from './pages/ProvinciaIntegra';
import { FormularioUnico } from './pages/FormularioUnico';
import { CuentasFAL } from './rest/models/CuentasFAL';
import { FormularioCuentasFAL } from './pages/FormularioCuentasFAL';




function App() {
  const today = new Date();
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6LdgGq8ZAAAAAEG8nW1r-y4kEa0za539rMxBRRwW">
      <TurnstileProvider sitekey={process.env.REACT_APP_TKN_SITEKEY!}>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <Routes>
            <Route
              path="*"
              element={
                <HomeRedirect />
              }
            />
            <Route path="/SemiPresencial/TarjetaPactar" element={<TarjetasPactar />}></Route>
            <Route path="/SemiPresencial/ComercioPactar" element={<ComerciosPactar />}></Route>

            <Route path="/SemiPresencial/PaquetesNyP" element={<PaquetesNyPSP/>}></Route>
            <Route path="/SemiPresencial/TarjetasCredito" element={<TarjetasCreditoSP></TarjetasCreditoSP>}></Route>
            <Route path="/SemiPresencial/PaquetesBancaIndividuo" element={<PaquetesBancaIndividuoSP></PaquetesBancaIndividuoSP>}></Route>
            <Route path="/SemiPresencial/PrestamoPersonal" element={<PrestamosPersonalSP></PrestamosPersonalSP>}></Route>
            <Route path="/BloqueoBip" element={<BloqueoBip />}></Route>
            <Route path="/SemiPresencial/CajasDeSeguridad/:id" element={<CajasDeSeguridad />}></Route>
            <Route path="/CanjePOPCuentaDNI/CanjeForm" element={<AdhesionComerciosCanje></AdhesionComerciosCanje>}></Route>
            <Route path="/SemiPresencial/AdhesionComercioProvinciaCompras" element={<AdhesionComercioProvinciaCompras />}></Route>
            <Route path="/Arrepentimiento/PreSolicitud" element={<ArrepentimientoPreSolicitud/>}></Route>
            <Route path="/Arrepentimiento/Index" element={<ArrepentimientoIndex/>}></Route>
            <Route path="/DemandaColectivaIFE/IFEForm" element={<DemandaColectivaIFE></DemandaColectivaIFE>}></Route>
            <Route path="/DocumentacionAdjunta" element={<FileUploadPage />}></Route>
            <Route path="/ConfirmacionEntradasEvento/resultado/:codigoUnico" element={(today >= CONFIRMACION_ENTRADAS_VIG_START && today <= CONFIRMACION_ENTRADAS_VIG_END) ? <ConfirmacionEntradas /> : <HomeRedirect />}></Route>
            <Route path="/SemiPresencial/CtaPersonajuridica" element={<CtaPersonaJuridicaPresolicitud />}></Route>
            <Route path="/SemiPresencial/Adhesionprestamoadistancia" element={<AdhesionPortalPrestamosADistancia />}></Route>
            {/* <Route path="/SemiPresencial/FormularioUnicoEmpresa/:producto/:canal" element={<FormularioUnico />}></Route> */}
            <Route path="/SemiPresencial/SubsidioDamnificadosBahiaBlanca" element={<CreditoDamnificadosBahiaBlanca />}></Route>
            <Route path="/PUSF" element={<PUSFForm />}></Route>
	    <Route path="/AdhesionComercios/Index" element={<AdhesionComercios/>}></Route>
            <Route path="/AdhesionComercios/PreSolicitud" element={<AdhesionComerciosPreSolicitudForm />}></Route>
            <Route path="/ProvinciaIntegra" element={<ProvinciaIntegra />}></Route>
	    <Route path="/CuentasFAL" element={<FormularioCuentasFAL />}></Route>  

            {/* 
        <Route path="/SemiPresencial/AdjudicacionAnticipada" element={<AdjudicacionAnticipada />}></Route>
        <Route path="/SemiPresencial/TarjetasCreditoClientelaGeneral" element={<TarjetasCreditoClientelaGeneralSP></TarjetasCreditoClientelaGeneralSP>}></Route>         <Route path="/SemiPresencial/LineaDeInversion" element={<LineaDeInversion/>}></Route>
        <Route path="/SemiPresencial/CreditoImpulsoComercioBonaerense" element={<CreditoImpulsoComercioBonaerense />}></Route>
        <Route path="/SemiPresencial/InclusionFinanciera" element={<InclusionFinanciera/>}></Route>
        <Route path="/AdhesionComercios/PreSolicitud" element={< AdhesionComercioPreSolicitudSP></ AdhesionComercioPreSolicitudSP>}></Route>
        <Route path="/AdhesionComercios/Index" element={<AdhesionComercioIndex></ AdhesionComercioIndex>}></Route>
        <Route path="/SemiPresencial/CuentaRegularizacionDeActivos" element={<RegularizacionDeActivos />}></Route>*/}
            
          </Routes>

        </BrowserRouter>
      </TurnstileProvider>
    </GoogleReCaptchaProvider>
  );
}
export default App;
